import {type FC} from "react";
import {useTranslation} from "react-i18next";

const UnderMaintenancePage: FC = () => {
  const {t} = useTranslation();

  return (
    <div className="text-neutral-black flex h-1/2 min-h-[50vh] flex-col items-center justify-center gap-10 px-10 sm:px-20">
      <span className="text-5xl sm:text-6xl">👷🚧</span>
      <span className="text-center text-5xl font-medium sm:text-6xl">{t("underMaintenance")}</span>
    </div>
  );
};

export default UnderMaintenancePage;
